import React from 'react'
import { alumniInfo } from '../components/data'
import { graphql, useStaticQuery } from 'gatsby'

import Banner from '../components/banner'
import Layout from '../components/layouts/mainLayout'
import FocusPoint from "../components/focus-point"
import Paragraph from '../components/layouts/para'

import "../styles/alumni.scss"
import "../styles/universal.scss"
import Head from '../components/head'

const Alumni = () => {

    const data = useStaticQuery(graphql`
        query {
            BannerImg: file(relativePath: {eq:"ms.jpg"}){
                ...FluidImageFragment
            }
        }
    `)
    
    return (
        <Layout>
            <Head title="Alumni"/>
            <Banner
                title="ALUMNI" 
                img={data.BannerImg.childImageSharp.fluid}
                height="small"
            />
            <FocusPoint 
                title="Our Alumni"
                subtitle=""
            />
            <Paragraph>
                <p>Numerous Redbirds players have been selected in the amateur draft of Major League Baseball, earned scholarships to top NAIA universities, top-ranked junior colleges, or received academic scholarships to pursue their studies. The following is a list of some of the players who have worn the Redbirds uniform and have moved on to the next level.</p>
            </Paragraph>
            <div className="alumni">
                {alumniInfo.map(( details, index ) => (
                    <AlumniList key={index} details={details} />
                ))}
            </div>
        </Layout>
    )
}

const AlumniList = ({ details }) => {
    return (
        <>
            <div className="alumni-list">
                <h2>{details.year}</h2>
                {details.names.map((name, index)=> (
                    <p key={index}><span>{name} - </span>{details.university[index]}</p>
                ))}
            </div>
        </>
        
    )
}

export default Alumni
